var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('side-card',{attrs:{"absolute":true,"loading":_vm.isLoading,"width":!_vm.fullscreenBreakpoint ? '1200px' : '100%',"hideTitle":true,"fullscreen":_vm.fullscreenBreakpoint},on:{"close":_vm.close}},[_c('v-container',[(_vm.isLoading)?_c('v-skeleton-loader',{attrs:{"type":"list-item-two-line"}}):(_vm.value)?_c('template-detail',{staticClass:"mt-1",attrs:{"value":_vm.value,"hideBreadCrumbs":true,"showDetailButton":true},on:{"onDelete":() => {
          _vm.$emit('onDelete');
          _vm.close();
        }}}):_c('latest-entries-card-empty')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }